import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
 import styled from "../../../calendars/LessonCalendar.module.css";
import { auth, db } from "../../../../firebase/firebase.js";
import {FaTrash, FaEdit} from "react-icons/fa"
import { collection, query, where, getDocs, doc, deleteDoc } from "firebase/firestore";
import {
  TEACHER_CALENDAR_CULTURE,
  teacherCalendarMessages,
  useTeacherCalendarLocale,
} from "../../../../constants/teacherCalendar";
import {
  canTeacherJoinLesson,
  getLessonRoomPath,
} from "../../../../utils/lessonLinks.js";
import { API_BASE } from "../../../../config/api.js";

const localizer = momentLocalizer(moment);
const TeacherClasses = () => {
  const { t } = useTranslation();
  useTeacherCalendarLocale();
async function getIdToken() {
const user = auth.currentUser;
if (!user) throw new Error("Not authenticated");
return await user.getIdToken();
}
  const eventCollectionRef = collection(db, "events");

  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchStudentEvents = async () => {
      try {
        const teacherID = auth.currentUser.uid; 
        const q = query(eventCollectionRef, where("teacherID", "==", teacherID));
        const querySnapshot = await getDocs(q);
  
        const fetchedEvents = querySnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            ...data,
            id: doc.id, 
            start: data.start.toDate(), 
            end: data.end.toDate(), 
          };
        });
  
        setEvents(fetchedEvents); 
      } catch (error) {
        console.error("Error fetching teacher events:", error);
      }
    };
  
    fetchStudentEvents(); 
  }, []);
const removeEvent = async (eventId, eventStartTime) => {
  const currentTime = new Date();
  const start = eventStartTime instanceof Date ? eventStartTime : new Date(eventStartTime);
  const timeDifference = start.getTime() - currentTime.getTime();

  if (timeDifference <= 2 * 60 * 60 * 1000) {
    alert("You cannot delete an event less than 2 hours before its start time.");
    return;
  }

  if (!window.confirm(t("LessonCalendar.confirmDelete"))) {
    return;
  }

  try {
    const idToken = await getIdToken();
    const resp = await fetch(`${API_BASE}/delete-zoom-meeting/${eventId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    if (!resp.ok) {
      
      const err = await resp.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${resp.status}`);
    }
    setEvents((prev) => prev.filter((e) => e.id !== eventId));
    // refreshCalendar();
    alert("Event and video call deleted successfully.");
  } catch (error) {
    console.error("Error deleting event:", error);
    alert(error.message || "Failed to delete event");
  }
};
 
  const CustomEvent = ({ event }) => (
    <div>
      <strong>{event.title}</strong>
      <div>
       {canTeacherJoinLesson(event) && (
         <a className={styled.link} href={getLessonRoomPath(event.id)}>
           Join video call
         </a>
       )}
     </div>
      <FaTrash className={styled.trashBin} onClick={() => removeEvent(event.id, event.start)} />
    </div>
  );

  return (
    <>
      <div className={styled.app}>
        <Calendar
          localizer={localizer}
          messages={teacherCalendarMessages}
          culture={TEACHER_CALENDAR_CULTURE}
          defaultDate={new Date()}
          defaultView="week"
          events={events.map((event) => ({
            ...event,
            start: new Date(event.start), 
            end: new Date(event.end),
          }))}
          selectable={false}
          step={30}
          timeslots={1}
          style={{ height: "100vh" }}
          formats={{
            timeGutterFormat: (date, culture, localizer) =>
              localizer.format(date, "HH:mm", culture),
          }}
          components={{
            event: CustomEvent,
          }}
        />
      </div>
    </>
  );
}

export default TeacherClasses